import { render, staticRenderFns } from "./TextForm.vue?vue&type=template&id=3a302710&scoped=true&"
import script from "./TextForm.vue?vue&type=script&lang=ts&"
export * from "./TextForm.vue?vue&type=script&lang=ts&"
import style0 from "./TextForm.vue?vue&type=style&index=0&id=3a302710&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a302710",
  null
  
)

export default component.exports